import { render, staticRenderFns } from "./IAReport.vue?vue&type=template&id=69015e62&"
import script from "./IAReport.vue?vue&type=script&lang=js&"
export * from "./IAReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports